var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCycleWorkScheme(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 200",
    style: {
      enableBackground: "new 0 0 360 200"
    },
    xmlSpace: "preserve",
    width: "3rem",
    height: "3rem",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0 { fill: #333d45; }\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290,200c-38.6,0-70-31.4-70-70c0-20.6,9.1-39.2,23.3-52l-10.2-15.3L178,135.9c-1.9,2.7-4.8,4.1-8,4.1h-30.8 c-4.8,33.9-33.9,60-69.2,60c-38.6,0-70-31.4-70-70s31.4-70,70-70c12.2,0,23.6,3.1,33.6,8.6L125,40H90c-5.5,0-10-4.5-10-10 s4.5-10,10-10h60v20h68l-13.3-20H170c-5.5,0-10-4.5-10-10s4.5-10,10-10h40c3.3,0,6.4,1.7,8.3,4.4L260,66.9c9.1-4.4,19.2-6.9,30-6.9 c38.6,0,70,31.4,70,70S328.6,200,290,200z M70,140c-8.3,0-13-9.4-8-15.9l29.4-39.2C84.8,81.7,77.7,80,70,80c-27.5,0-50,22.5-50,50 s22.5,50,50,50c24.2,0,44.4-17.2,49.1-40H70z M119.1,120c-1.9-8.8-5.9-16.7-11.7-23.1L90,120H119.1z M210,60h-75l-15.5,20.6 C130,90.9,137,104.7,139.2,120H165L210,60z M290,80c-6.7,0-13,1.4-18.9,3.8l27.2,40.6c3.1,4.7,1.9,10.9-2.7,13.9 c-1.7,1.2-3.8,1.7-5.6,1.7c-3.3,0-6.4-1.6-8.3-4.5l-27.2-40.6c-8.9,9.1-14.5,21.4-14.5,35.2c0,27.5,22.5,50,50,50s50-22.5,50-50 S317.5,80,290,80z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycleWorkScheme);
export default __webpack_public_path__ + "static/media/Cycle_Work_Scheme.3fdfd567ca913bb8f43c6162d292e2a4.svg";
export { ForwardRef as ReactComponent };